// What undo and redo, and the open scene's changes from elsewhere, change underneath the editor: the parts of the
// editor that show those rows subscribe here and read again.

/** A change to rows the editor shows. */
export type EditorChange =
  /** A scene's settings. */
  | { kind: 'scene'; sceneId: string }
  /** A story's fields, which every scene of it shows. */
  | { kind: 'story'; storyId: string }
  /** A library item renamed. */
  | { kind: 'libraryItem'; assetTypeId: string; displayName: string }
  /** Library items came or went. */
  | { kind: 'library' }
  /** A clip type (an animation) changed. */
  | { kind: 'clipType'; clipTypeId: string }
  /** A material preset changed. */
  | { kind: 'materialPreset'; materialTypeId: string }
  /** An asset instance's materials changed. */
  | { kind: 'materials'; assetInstanceId: string }
  /** A screen message style changed. */
  | { kind: 'screenMessageStyle'; typeId: string }
  /** An anchor (Immersal, image or geospatial) came, changed or went. */
  | { kind: 'anchors' };

const listeners = new Set<(change: EditorChange) => void>();

/** Calls `listener` with every change; returns the unsubscribe. */
export function onEditorChange(listener: (change: EditorChange) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Tells every listener; one that fails is logged and the rest still hear it. */
export function announce(change: EditorChange): void {
  for (const listener of [...listeners]) {
    try {
      listener(change);
    } catch (error) {
      console.warn('[editorChanges] a listener failed', error);
    }
  }
}
